import { css } from 'styled-components'

export const Datapoints = css`
  transition: top 0.3s ease, bottom 0.3s ease, left 0.3s ease, right 0.3s ease;
  font-size: 0.9rem;
  font-weight: 100;
  background-color: var(--color-backgroundFront);
  border: 1px solid var(--color-softStroke);
  box-shadow: var(--shadow-shadowElevation2);
  border-radius: 3px;
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  margin: 0.5rem 0;
  max-width: ${({ maxWidth = '15rem', theme }) =>
    theme.screenSize.screen.current === 's' ? '94%' : maxWidth};
  min-width: 10rem;

  .Icon {
    color: var(--color-main);
    width: 1rem;
    &.close-button {
      display: ${({ theme }) => theme.screenSize.screen.current !== 's' && 'none'};
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }

  .Datapoints__detail-title {
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 0.5rem;
    display: block;
    width: 100%;
  }

  .Datapoints__detail {
    font-weight: 100;
    text-transform: uppercase;
    line-height: 1.4;
  }

  .Loader {
  }
`
